import { matchPath } from 'react-router-dom';

import { getConfigValues } from 'src/config';
import Routes from 'src/config/routes';

// These align with the href's for our <NavigationHeader /> component
type NavigationLinkId =
  | 'none'
  | 'navbar-nav-item-buy-a-business'
  | 'navbar-nav-item-sell-a-business'
  | 'navbar-nav-item-franchise'
  | 'navbar-nav-item-brokers'
  | 'navbar-nav-item-blog';

const routeToNavigationLinkIdMap: Record<
  keyof typeof Routes,
  NavigationLinkId
> = {
  // buy-a-business
  ROOT: 'navbar-nav-item-buy-a-business',
  BOOSTED_AD: 'navbar-nav-item-buy-a-business',
  ONBOARDING: 'navbar-nav-item-buy-a-business',
  UNSUBSCRIBE: 'navbar-nav-item-buy-a-business',
  BUYER_PREFERENCES: 'navbar-nav-item-buy-a-business',
  PREFERENCES_SUBMITTED: 'navbar-nav-item-buy-a-business',
  RECOMMENDATION_UNSUBSCRIBE: 'navbar-nav-item-buy-a-business',
  // sell-a-business
  PRIVATE_SELLER_SEM: 'navbar-nav-item-sell-a-business',
  PRIVATE_SELLER_SEM_V2: 'navbar-nav-item-sell-a-business',
  LISTING_ENQUIRIES: 'navbar-nav-item-sell-a-business',
  PAYMENT: 'navbar-nav-item-sell-a-business',
  PAYMENT_CONFIRM: 'navbar-nav-item-sell-a-business',
  PAYMENT_SUCCESS: 'navbar-nav-item-sell-a-business',
  PAY_PER_ENQUIRY_CONTRACT: 'navbar-nav-item-sell-a-business',
  FREEMIUM_CONTRACT: 'navbar-nav-item-sell-a-business',
  PACKAGES: 'navbar-nav-item-sell-a-business',
  DASHBOARD: 'navbar-nav-item-sell-a-business',
  PRICE_GUIDE: 'navbar-nav-item-sell-a-business',
  PRICE_GUIDE_ESTIMATION: 'navbar-nav-item-sell-a-business',
  PRICE_GUIDE_OPERATIONS: 'navbar-nav-item-sell-a-business',
  POST_LISTING: 'navbar-nav-item-sell-a-business',
  RENEW_LISTING: 'navbar-nav-item-sell-a-business',
  RENEW_LISTING_SUCCESS: 'navbar-nav-item-sell-a-business',
  // franchise
  FRANCHISE_HUB: 'navbar-nav-item-franchise',
  FRANCHISE_DIRECTORY: 'navbar-nav-item-franchise',
  // Deliberately "none"
  ERROR_PAGE: 'none',
  PAGE_NOT_FOUND: 'none',
  PROFILE_DETAILS: 'none',
  PROFILE_SAVED_BUSINESSES: 'none',
  PROFILE_SAVED_SEARCHES: 'none',
  MARKETPLACE_INSIGHTS: 'none',
  // .NET URLs
  CREATE_AD_URL: 'none',
  EDIT_AD_URL: 'none',
  PRIVATE_SELLER_INFO: 'none',
  SELLING_A_BUSINESS: 'none',
  TERMS_AND_CONDITIONS: 'none',
  VIEW_AD_URL: 'none',
  // External URLs
  SIGN_IN_URL: 'none',
  SIGN_OUT_URL: 'none',
  BUSINESS_RESOURCES: 'none',
  ASSET: 'none',
  AD_WRITING_TIPS: 'none',
  BUYER_SCREENING_GUIDE: 'none',
  BUSINESS_SALE_CHECKLIST: 'none',
};

export const getSelectedNavigationLinkIdForPath = (currentPath: string) => {
  const routeKeyValue = Object.entries(Routes).find(([_, path]) =>
    matchPath(path, currentPath),
  );

  if (routeKeyValue === undefined) {
    if (getConfigValues().ENVIRONMENT === 'local') {
      throw new Error(
        `Cannot match current path with defined application routes. Please update the route configuration. Curret path: ${currentPath}`,
      );
    }
    return 'none';
  }

  const [routeName] = routeKeyValue;
  const tab = routeToNavigationLinkIdMap[routeName as keyof typeof Routes];

  return tab;
};
